<template>
  <div class="page">
    <div class="logo">
      <img src="../assets/dl_logo.png" alt="">
      <div class="title">用户登录</div>
    </div>
    <van-form class="from">
      <van-field v-model="form.mobile" placeholder="请输入手机号" class="input"/>
      <van-field v-model="form.password" placeholder="请输入密码" type="password"  class="input"/>
      <div style="display: flex">
        <van-field v-model="form.codes" placeholder="请输入验证码" style="width: 50%" class="input"/>
        <img class="captcha" :src="codeUrl" @click="getCaptcha" style="height: 40px"/>
      </div>
      <van-button class="btn" type="primary" size="large" block @click="sumbit">登录</van-button>
    </van-form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "loginByMobile",
  data() {
    return {
      form: {
        mobile: '',
        password: '',
        codes: ''
      },
      codeUrl: '',
      guid: '',
    }
  },
  mounted() {
    this.guid = this.getGuid()
    this.getCaptcha()
  },
  methods: {
    getGuid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    },
    getCaptcha() {
      axios.get(`/api/School/ORG/Teacher/Captcha?guid=${this.guid}`).then(res => {
        if (res.data.Succeeded) {
          let base64 = res.data.Data.DATA
          this.codeUrl = 'data:image/jpeg;base64,' + base64; //不加上这串字符，在页面无法显示
        }
      })
    },
    sumbit() {
      let self = this
      let {mobile, password, codes} = this.form
      if (!mobile) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!password) {
        this.$message.warning('请输入密码')
        return;
      }
      if (!codes) {
        this.$message.warning('请输入验证码')
        return;
      }
      this.whale.remote.getResult({
        url: `/api/School/ORG/Teacher/LoginByMobile?guid=${this.guid}&mobile=${mobile}&password=${password}&codes=${codes}&wxcode=${self.$route.query.wxcode}`,
        completed(res) {
          if (res.SUCCESS) {
            localStorage.setItem("loginToken", res.DATA.jwt.token);
            localStorage.setItem('userInfo', JSON.stringify(res.DATA.user))
            localStorage.setItem("tokenExpires", res.DATA.jwt.ExpiresLong);
            if (self.$route.query.mrl) {
              self.$router.push(self.$route.query.mrl)
            } else {
              self.$router.push("/")
            }
          } else {
            self.$message.warning(res.MESSAGE)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.page{
  width: 100%;
  height: 100vh;
  background: #fff;
  padding-top: 70px;
}
.logo{
  text-align: center;
}
.logo img{
  width: 200px;
  height: 50px;
  margin-bottom: 60px;
}
.logo .title{
  font-size: 20px;
  color: #566e8c;
  margin-bottom: 20px;
}

.from{
  padding: 0 30px;
}

.btn{
  margin-top: 50px;
  background: #1e9fff;
  height: 45px;
}

.input{
  margin-bottom: 10px;
}
</style>